// Microsoft's four-square logo. Its colours are Microsoft's brand colours, which
// the logo must keep in both themes: the one place they are allowed.
export default function MicrosoftLogo({ className }: { className?: string }): JSX.Element {
  return (
    <svg className={className} viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="9" height="9" fill="#F25022" />
      <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
      <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
      <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
    </svg>
  );
}
